module.exports = __webpack_public_path__ + "img/encabezado-form.d5d1ed89.gif";